import React, {Component} from 'react';
import PropTypes from 'prop-types';
import NavigationLink from '../NavigationLink/NavigationLink';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

let data = SetComponentLanguage(LocalizedStrings, en, fr);

class AdminNavigation extends Component {
    render() {
        return (
            <div className="showtix-navigation__client">
                <div className="showtix-badge showtix-background__grey-3">
                    {data.title}
                </div>
                <ul className="showtix-navigation__list">
                    {data.navigationLinks.map((navigationLink, i) =>
                        <NavigationLink
                            key={i}
                            navigationLink={navigationLink}
                            toggleNav={this.props.toggleNav} />
                    )}
                </ul>
            </div>
        );
    }
}

AdminNavigation.propTypes = {
    toggleNav: PropTypes.func
}

export default AdminNavigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/AdminNavigation/AdminNavigation.js